/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type FeaturedCommentsContainer_viewer = {
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_viewer" | "PostCommentFormContainer_viewer">;
    readonly " $refType": "FeaturedCommentsContainer_viewer";
};
export type FeaturedCommentsContainer_viewer$data = FeaturedCommentsContainer_viewer;
export type FeaturedCommentsContainer_viewer$key = {
    readonly " $data"?: FeaturedCommentsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "current",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeaturedCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'b9098af5fbb347c7635a23b7fad8f6eb';
export default node;
